{
  "povzetek": {
    "title": "Summary",
    "skupno30": "Last 30 days",
    "skupno90": "Last 90 days",
    "skupno365": "Last 365 days",
    "vsiO": "All completed flights",
    "povprecje": "Average flight duration",
    "najveckratV": "Most frequently flown aircraft"
  },
  "povzetekLabel": {
    "dan": "Day",
    "slepo": "Instrument"
  },
  "table": {
    "datum": "Date",
    "letalisce": "Airport",
    "trajanje": "Duration",
    "vzlet": "Takeoff",
    "diaryTitle": "Diary Entries"
  },
  "modal": {
    "datum": "Date:",
    "odhodCas": "Departure time:",
    "kilometri": "Distance flown (km):",
    "trajanjeDan": "Flight duration (day):",
    "trajanjeSlepo": "Flight duration (instrument):",
    "stLetov": "Number of flights:",
    "odhod": "Departure:",
    "krajO": "Departure location:",
    "nacinStarta": "Launch method:",
    "zrakoplov": "Aircraft:",
    "reg": "Registration:",
    "vodjaZ": "Pilot in command:",
    "opomba": "Note:"
  },
  "labelsLJ": {
    "casO": "Departure time:",
    "casP": "Arrival time:",
    "model": "Aircraft model:",
    "reg": "Aircraft registration:",
    "vodjaZ": "Pilot in command:",
    "posadka": "Single / Multi crew:",
    "pogoji": "Flight conditions:",
    "pD": "Day",
    "pN": "Instrument",
    "stPristankov": "Number of landings:",
    "ttof": "TTOF:",
    "op": "Flight mode:",
    "opD": "Day",
    "opN": "Instrument",
    "vp": "Pilot role:",
    "fstd": "FSTD time:",
    "opomba": "Note:",
    "pristanek": "Select landing:",
    "regL": "Select glider registration:",
    "nacinStarta": "Launch method:"
  },
  "optionsLJ": {
    "aerozaprega": "Aerotow",
    "vitla": "Winch launch"
  },
  "buttons": {
    "urediPodatke": "Edit data",
    "posodobiPodatke": "Update data",
    "brisiZapis": "Delete record",
    "brisiIzbiro": "Clear selection",
    "natisni": "Print",
    "poslji": "Send"
  }
}